import { ExpenseStatus } from 'gql/index';
import { MessageDescriptor, defineMessages } from 'react-intl';

export const expenseStatusMessages: Record<ExpenseStatus, MessageDescriptor> = defineMessages({
  NotPaid: { id: 'Billed' },
  Paid: { id: 'Paid' }
});